export default "__VITE_ASSET__Boruzw3___"